import React from "react";

interface IconProps {
  isActive?: boolean;
}

const SalesTeamIcon: React.FC<IconProps> = ({ isActive = false }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[20px] h-[20px]"
  >
    <path
      d="M12.5 14.1668L15.8333 10.8335L12.5 7.50018"
      stroke={isActive ? "#85BDFF" : "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M4.16602 10.8335H15.8327"
      stroke={isActive ? "#85BDFF" : "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M4.16602 18.3332C6.00688 18.3332 7.49935 16.8407 7.49935 14.9998V10.8332H4.16602C2.32516 10.8332 0.832693 12.3257 0.832693 14.1665C0.832693 16.0073 2.32516 17.4998 4.16602 17.4998"
      stroke={isActive ? "#85BDFF" : "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M4.16602 1.6665C6.00688 1.6665 7.49935 3.159 7.49935 4.99984V9.1665H4.16602C2.32516 9.1665 0.832693 7.674 0.832693 5.83317C0.832693 3.99234 2.32516 2.49984 4.16602 2.49984"
      stroke={isActive ? "#85BDFF" : "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export default SalesTeamIcon;
